Apt.fn.extend('maps', {}, {
	/**
	 * Initialize element model
	 */
	initModel() {
		const scope = this;
		const conf = scope.conf;

		if (conf.basic) {
			scope.$parent[0].classList.add('-basic');
		}

		scope.$overlay = $('<div class="map-overlay"/>');
		scope.$overlay.appendTo(scope.$parent);

		scope.model = $.app.make('map-' + scope.uid, {
			target: scope.$overlay,
			view: 'maps.elements',
			model: Object.assign({
				bar: ! conf.single && ! conf.basic,
				basic: conf.basic,
				controls: ! conf.basic,
				detail: conf.hideZoomMessage,
				detailed: scope.map.getZoom() >= scope.break,
				draw: !! scope.conf.onDraw,
				preview: conf.preview,
				single: conf.single,
				style: conf.style,
				tab: 'layer'
			}, conf.model)
		});

		scope.$public.ready(() => {
			LS.util.idle([
				scope.initReset,
				scope.initZoom,
				scope.initPitch,
				scope.initResize,
				scope.initLabel,
				scope.initInspect,
				scope.bindOptions
			], scope);
		});
	},

	/**
	 * Initialize inspector
	 */
	initInspect() {
		const scope = this;

		$.events.on('$mapInspect', 'change', (e, el) => {
			if (el.checked) {
				scope.loadInspect();
			} else if (scope.inspect) {
				scope.inspect.$destroy();
			}
		}, {
			delegate: scope.$overlay,
			namespace: scope.uid
		});
	},

	/**
	 * Load inspector
	 *
	 * @param {Object} [e]
	 */
	loadInspect(e) {
		const scope = this;

		LS.util.load('inspect', () => {
			if (scope.inspect) {
				scope.inspect.$destroy();
			}

			scope.inspect = Apt.fn.inspect()
				.init(scope, e);

			LS.analytics.interact('map', 'inspect');
		});
	},

	/**
	 * Register map styling control functionality
	 */
	bindOptions() {
		const scope = this;
		const pub = scope.$public;

		$.events.on('$mapOptionsToggle', 'mousedown', () => {
			scope.model.$get('showOptions') ?
				scope.removeOptions() :
				scope.addOptions();
		}, {
			delegate: scope.$overlay,
			namespace: scope.uid
		});

		pub.bind('map', 'contextmenu', e => {
			scope.loadInspect(e);
		});

		if (scope.conf.onDraw) {
			$$('mapDraw').on('mousedown', () => {
				const draw = scope.draw;

				if (! draw) {
					scope.setState();
				}

				LS.util.load('draw', () => {
					if (draw) {
						pub.removeDraw(true);

						scope.model.$drop('message');
					} else {
						scope.draw = Apt.fn.draw()
							.init(scope.$public, coordinates => {
								scope.conf.onDraw(coordinates);

								scope.model.$drop('message');
							}, LS.filters.get('geometry'));

						scope.model.$set('drawing', true);

						scope.setState(true);

						scope.model.$set('message', 'Draw your search area');

						LS.analytics.interact('map', 'draw');
					}
				}, true, false);
			}, {
				init: !! LS.filters.get('geometry'),
				namespace: scope.uid
			});
		}
	},

	/**
	 * Show controls
	 */
	addOptions() {
		const scope = this;
		const pub = scope.$public;

		pub.hideTooltip();

		scope.model.$set('showOptions', true);

		scope.tabs = Apt.fn.tab()
			.init(scope.$overlay, id => {
				scope.model.$set('tab', id);
			});

		pub.bind('map', 'click', () => {
			scope.removeOptions();
		}, true);

		pub.bind('map', 'move', () => {
			scope.removeOptions();
		}, true);
	},

	/**
	 * Hide controls
	 */
	removeOptions() {
		const scope = this;

		if (scope.tabs) {
			scope.tabs.$destroy();

			scope.tabs = null;
		}

		scope.model.$drop('showOptions');
	}
});